module.exports = __webpack_public_path__ + "static/img/about_fw_3.980f2c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about_fw_3.png
// module id = pCof
// module chunks = 1